import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getAllPoolTransactions, GetAllPoolTransactionsParams} from '../api';
import {QUERY__ALL_POOL_TRANSACTIONS} from '../queryKeys';
import {Transaction} from '../types';

export const useGetAllPoolTransactions = <
  SelectedData = GetListOutput<Transaction>,
>(
  params: GetAllPoolTransactionsParams,
  options?: QueryOptionsForList<Transaction, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__ALL_POOL_TRANSACTIONS, params],
    queryFn: () => getAllPoolTransactions(params),
    ...options,
  });
};
